import type { BadgeStatusIndicatorColor } from '@customerio/pluma-components/react';
import { sqlImportIsScheduled, type SqlImport } from '@/services/db/sql-import/entity';

export interface SqlImportStatusDetails {
  color: BadgeStatusIndicatorColor;
  label: string;
}

/**
 * The badge an import shows for its lifecycle state. Scheduled wins over active
 * (an active import whose first run is still in the future), paused is an
 * activated import that was stopped, and a draft was never activated.
 */
export function sqlImportStatusDetails(
  sqlImport: Pick<SqlImport, 'active' | 'is_draft' | 'start_at'>,
  nowInSeconds: number,
): SqlImportStatusDetails {
  const isScheduled = sqlImportIsScheduled(sqlImport, nowInSeconds);
  if (sqlImport.active && isScheduled) {
    return { color: 'grey', label: 'Scheduled' };
  }
  if (sqlImport.active) {
    return { color: 'green', label: 'Active' };
  }
  if (sqlImport.is_draft) {
    return { color: 'yellow', label: 'Draft' };
  }
  return { color: 'grey', label: 'Paused' };
}
